import React, { FC, useState, useEffect, FormEvent } from "react";
import InputMask from 'react-input-mask';
import TextField from "@mui/material/TextField";
// localizations
import { withTranslation, useTranslation } from "react-i18next";

const InputMaskField = (props) => {
  const { InputProps,sx, type, label,autoFocus, className, variant, id, name, value, onChange,mask,formatChars } = props

  return (
    <InputMask maskChar={null} mask={mask} formatChars={formatChars} value={value} onChange={onChange}>
      {(inputProps) => <TextField {...inputProps}
        type={type} sx={sx} id={id} autoFocus={autoFocus} name={name} variant={variant} className={className} label={label} InputProps={InputProps} />}
    </InputMask>
  )
}

export default withTranslation()(InputMaskField);